import ApiService from "@/core/services/api.service";
const _ = require('lodash');

export const PATH_OKR = "okr";
export const GET_LIST_OKR = "GET_LIST_OKR";
export const GET_OKR_DETAIL = "GET_OKR_DETAIL";
export const CREATE_OKR = "CREATE_OKR";
export const UPDATE_OKR = "UPDATE_OKR";
export const DELETE_OKR = "DELETE_OKR";
export const UPDATE_DEADLINE_OKR = "okr/update-progress"
export const UPDATE_STATUS_OKR = "okr/update-status";
export const SHARE_EXP_OKR = "okr/exp";
export const FIND_USER_BY_KEYWORD = "user/filter"
export const IMPORT_OKR = "okr/import"
export const GET_LIST_WAITING_KRA = "kra-history/list"
export const GET_LIST_KRA_BY_USER = "kra-history/list-by-user"
export const KRA_APPROVE = "kra-history/approve"
export const TEAM_LEAD_INDEX_PATH = "criteria-teamlead"
export const GET_TEAM_LEAD_INDEX_LIST = "GET_TEAM_LEAD_INDEX_LIST"
export const IMPORT_INDEX_TEAM_LEAD = "criteria-teamlead/import"
export const DELETE_INDEX_TEAM_LEAD = "DELETE_INDEX_TEAM_LEAD"
export const UPDATE_INDEX_TEAM_LEAD = "UPDATE_INDEX_TEAM_LEAD"
export const MINUS_POINT_PATH = "minus-point"
export const IMPORT_MINUS_POINT = "IMPORT_MINUS_POINT"
export const GET_LIST_MINUS_POINT = "GET_LIST_MINUS_POINT"
export const UPDATE_MINUS_POINT = "UPDATE_MINUS_POINT"
export const DELETE_MINUS_POINT = "DELETE_MINUS_POINT"

const state = {
    errors: null,
};

const getters = {};

const actions = {
    [GET_LIST_OKR](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(PATH_OKR, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_OKR_DETAIL](context, id) {
        return new Promise((resolve) => {
            ApiService.query(`${PATH_OKR}/${id}`).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [UPDATE_OKR](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve, reject) => {
            ApiService.put(`${PATH_OKR}/${id}`, rest).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [DELETE_OKR](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(PATH_OKR, id).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [CREATE_OKR](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH_OKR, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [SHARE_EXP_OKR](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve, reject) => {
            ApiService.post(`${SHARE_EXP_OKR}/${id}`, rest.data).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [UPDATE_STATUS_OKR](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve) => {
            ApiService.post(`${UPDATE_STATUS_OKR}/${id}`, rest).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [UPDATE_DEADLINE_OKR](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve, reject) => {
            ApiService.post(`${UPDATE_DEADLINE_OKR}/${id}`, rest).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [FIND_USER_BY_KEYWORD](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(FIND_USER_BY_KEYWORD, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [IMPORT_OKR](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(IMPORT_OKR, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [GET_LIST_WAITING_KRA](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_LIST_WAITING_KRA, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_LIST_KRA_BY_USER](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_LIST_KRA_BY_USER, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [KRA_APPROVE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(KRA_APPROVE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [IMPORT_INDEX_TEAM_LEAD](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(IMPORT_INDEX_TEAM_LEAD, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_TEAM_LEAD_INDEX_LIST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(TEAM_LEAD_INDEX_PATH, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
                reject(res);
            });
        });
    },
    [UPDATE_INDEX_TEAM_LEAD](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve, reject) => {
            ApiService.put(`${TEAM_LEAD_INDEX_PATH}/${id}`, rest).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [DELETE_INDEX_TEAM_LEAD](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(TEAM_LEAD_INDEX_PATH, id).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [IMPORT_MINUS_POINT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${MINUS_POINT_PATH}/import`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_LIST_MINUS_POINT](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(MINUS_POINT_PATH, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },
    [UPDATE_MINUS_POINT](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve, reject) => {
            ApiService.put(`${MINUS_POINT_PATH}/${id}`, rest).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [DELETE_MINUS_POINT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(MINUS_POINT_PATH, id).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
}

const mutations = {};
export default {
    state,
    actions,
    mutations,
    getters
};
